import { useTranslation } from 'react-i18next';
import classNames from './GoogleLoginError.module.scss';
import React, { useCallback, useMemo } from 'react';

import SVG from 'react-inlinesvg';
import oops from '@/assets/svg/oops.svg';
import TheButton from '../../TheButton/TheButton';
import userUtils from '@/utils/user';
import commonUtils from '@/utils/common';

export enum GoogleLoginErrorTypes {
  default = 'default',
  missing_google_permissions = 'missing_google_permissions',
  unauthorized = 'unauthorized',
}

interface GoogleLoginErrorProps {
  errorType?: GoogleLoginErrorTypes;
  onCloseBtnClick: () => void;
}

const GoogleLoginError = ({
  errorType = GoogleLoginErrorTypes.default,
  onCloseBtnClick,
}: GoogleLoginErrorProps) => {
  const { t } = useTranslation();
  const isMGWebsite = commonUtils.isMGWebsite();

  const emitOnClick = useCallback(() => {
    if (errorType === GoogleLoginErrorTypes.missing_google_permissions) {
      userUtils.logoutGoogleUser(true);
      return;
    }

    onCloseBtnClick();
  }, [errorType]);

  const texts = useMemo(() => {
    switch (errorType) {
      case GoogleLoginErrorTypes.missing_google_permissions:
        return {
          title: 'missingGooglePermissionsPopup.title',
          description: 'missingGooglePermissionsPopup.description',
          closeBtn: 'missingGooglePermissionsPopup.button',
        };
      case GoogleLoginErrorTypes.unauthorized:
        return {
          title: 'GoogleLoginProblemTitle',
          description: 'UnauthorizedLoginProblemDescription',
          closeBtn: 'ok',
        };
    }

    return {
      title: 'GoogleLoginProblemTitle',
      description: isMGWebsite ? 'MinasLoginProblemDescription' : 'GoogleLoginProblemDescription',
      closeBtn: 'ok',
    };
  }, [errorType]);

  return (
    <div className={classNames.googleLoginError}>
      <SVG src={oops} />
      <h2>{t(texts.title)}</h2>
      <span className={classNames.description}>{t(texts.description)}</span>
      <TheButton
        className={classNames.closeBtn}
        text={t(texts.closeBtn)}
        shouldRecolor={false}
        emitOnClick={emitOnClick}
      />
    </div>
  );
};

export default GoogleLoginError;
